import React, { useState, useEffect } from "react";
import styled from "@emotion/styled";
import useAppStore from "../appStore";
import { CloseCTA } from "./SVGIcons";
import { motion } from "framer-motion";

const CTABubble = () => {
  const chatOpen = useAppStore((state) => state.chatOpen);
  const setChatOpen = useAppStore((state) => state.setChatOpen);
  const [showCTA, setCTA] = useState(false);
  const variants = {
    open: { opacity: 1, x: 0, pointerEvents: "auto" },
    closed: { opacity: 0, x: -20, pointerEvents: "none" },
  };
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      if (!sessionStorage.getItem("ctaShown")) {
        setCTA(true);
        sessionStorage.setItem("ctaShown", "true");
      }
    }, 6000); // Run after 6 seconds

    if (chatOpen) {
      setCTA(false);
    }
    // Clear the timeout when the component unmounts
    return () => clearTimeout(timeoutId);
  }, [chatOpen]);

  return (
    <StyledCTABubble
      as={motion.button}
      variants={variants}
      initial="closed"
      animate={!chatOpen && showCTA ? "open" : "closed"}
      onClick={() => {
        setChatOpen(true);
        setCTA(false);
      }}
    >
      <p>I'm MO. How can I help you?</p>
      <CloseButton
        onClick={(e) => {
          e.stopPropagation();
          setCTA(false);
        }}
      >
        <CloseCTA />
      </CloseButton>
    </StyledCTABubble>
  );
};

const StyledCTABubble = styled.button`
  background: white;
  border-radius: 24px 24px 4px 24px;
  padding: 12px 20px;
  box-shadow: ${({ theme }) => theme.shadows.chat};
  width: 240px;
  font-size: 12px;
  line-height: 18px;
  color: rgba(17, 17, 17, 1);
  text-align: left;
  position: relative;
`;

const CloseButton = styled.div`
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #111;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0;
  left: 0;
  svg {
    width: 6px;
  }
`;

export default CTABubble;
